interface IProps {
  fill?: string;
  width?: string;
  height?: string;
}

function IconUpTopComponent({
  fill = "#3F9BC0",
  width = "8",
  height = "5",
}: IProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.24226 1.08511L3.53516 0.378006L-0.000377595 3.91354L0.706729 4.62065L4.24226 1.08511Z"
        fill={fill}
      />
      <path
        d="M6.36418 4.62111L7.07129 3.914L3.53576 0.378468L2.82865 1.08557L6.36418 4.62111Z"
        fill={fill}
      />
    </svg>
  );
}

export { IconUpTopComponent };
